import React from "react"
import { Row, Col, Form } from "react-bootstrap"
import { useDispatch } from "react-redux"
import { editUpload } from "../../../../Redux/WindscreenClaim/actions"
import FormLabel from "../../../shared/formLabel"

function FormEditUpload({ ...props }) {
  const { editBenefits, allProofDocuments, claimUploadListModel } = props

  const dispatch = useDispatch()

  function checkDocumentStatus(documentId) {
    var hasExists = claimUploadListModel.filter(doc => {
      return doc.documentId === documentId
    })

    return hasExists.length > 0
  }

  return (
    <Form.Group>
      <Row className={editBenefits ? "" : "hide"}>
        <FormLabel text="Claim Documents Uploaded" />
        <Col
          xs={12}
          md={6}
          className="marginTop10px"
          onClick={() => dispatch(editUpload())}
        >
          <p className="editUpload">Edit Upload</p>
        </Col>
      </Row>
      <Row className={"form-group " + (editBenefits ? "" : "hide")}>
        <Col>
          {allProofDocuments.map((item, index) => {
            return (
              <div key={`document_${index}`} className="row">
                <div
                  className={
                    "col-12 CheckBox documentUpload" +
                    (checkDocumentStatus(item.documentId)
                      ? " documentSelectedText"
                      : "")
                  }
                >
                  {item.description}
                </div>
              </div>
            )
          })}
        </Col>
      </Row>
    </Form.Group>
  )
}

export default FormEditUpload
